import React from 'react';
import { Eye, AlertTriangle, Lightbulb } from 'lucide-react';

export const InsightBox = ({ seeing, matters, doAbout, source }) => (
  <div className="mt-4 grid gap-3 sm:grid-cols-3" data-testid="insight-box">
    <div className="rounded-2xl border border-blue-200 bg-blue-50 p-3.5">
      <div className="mb-1.5 flex items-center gap-1.5">
        <Eye className="h-4 w-4 text-blue-600" />
        <p className="text-xs font-bold uppercase tracking-wider text-blue-700">What You're Looking At</p>
      </div>
      <p className="text-xs leading-relaxed text-slate-700">{seeing}</p>
    </div>
    <div className="rounded-2xl border border-violet-200 bg-violet-50 p-3.5">
      <div className="mb-1.5 flex items-center gap-1.5">
        <Lightbulb className="h-4 w-4 text-violet-600" />
        <p className="text-xs font-bold uppercase tracking-wider text-violet-700">What This Means</p>
      </div>
      <p className="text-xs leading-relaxed text-slate-700">{matters}</p>
    </div>
    <div className="rounded-2xl border border-amber-200 bg-amber-50 p-3.5">
      <div className="mb-1.5 flex items-center gap-1.5">
        <AlertTriangle className="h-4 w-4 text-amber-600" />
        <p className="text-xs font-bold uppercase tracking-wider text-amber-700">Why It Matters</p>
      </div>
      <p className="text-xs leading-relaxed text-slate-700">{doAbout}</p>
    </div>
    {source && <p className="mt-1 text-[10px] text-slate-400 sm:col-span-3">Source: {source}</p>}
  </div>
);

export const SourceBadge = ({ name, year }) => (
  <span className="inline-flex items-center gap-1 text-[10px] text-slate-400 bg-slate-50 border border-slate-100 px-2 py-0.5 rounded-full font-medium">
    {name} {year && `(${year})`}
  </span>
);
